// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3K5rR","rootSmall":"AddTileButton_rootSmall__32W42"};